import React, { useMemo } from "react";
import { Autocomplete, TextField, Chip, FormControl } from "@mui/material";

export const SelectorAccountsMUI = ({ cuentas, value, onChange }) => {
  const options = useMemo(() => {
    return (cuentas || []).map((c) => ({
      value: c.id_cuentas,
      label: c.nombre_fantasia || c.nombre + " " + c.apellido,
    }));
  }, [cuentas]);

  const selected = useMemo(() => {
    if (!value || value.length === 0) return [];
    return options.filter((o) => value.includes(o.value));
  }, [value, options]);

  return (
    <FormControl sx={{ width: "100%" }}>
      <Autocomplete
        multiple
        value={selected}
        onChange={(e, newValue) => {
          const ids = newValue.map((x) => x.value);
          onChange(ids);
        }}
        options={options}
        getOptionLabel={(option) => `${option.value} - ${option.label}`}
        renderInput={(params) => (
          <TextField {...params} label="Cuentas" />
        )}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              key={option.value}
              label={option.label}
              {...getTagProps({ index })}
            />
          ))
        }
      />
    </FormControl>
  );
};
